import { useContext } from 'react'

import { SelectFocusContext } from '../../../../context'

export function useSelectFocusContext() {
  const context = useContext(SelectFocusContext)

  return context
}
